(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["candelinas-category-page"] && !Shopify.designMode) return;
  try {
    
  (function () {
    /* CANDELINAS CUSTOM: add .loading class to the ATB on click so the bar
       animation fires. Cleared on cart events but never sooner than 700ms
       (matches tealight's typical fetch+UI duration so the animation runs
       for the same length). 4s safety timeout if no cart event fires. */
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('.cc-card .cc-atb[data-quick-shop-trigger]');
      if (!btn) return;
      btn.classList.add('loading');
      var t0 = performance.now();
      var cleared = false;
      var clear = function () {
        if (cleared) return;
        cleared = true;
        var elapsed = performance.now() - t0;
        var wait = Math.max(0, 700 - elapsed);
        setTimeout(function () { btn.classList.remove('loading'); }, wait);
      };
      document.addEventListener('quick-cart:open', clear, { once: true });
      document.addEventListener('quick-cart:updated', clear, { once: true });
      setTimeout(clear, 4000);
    }, true);

    /* CANDELINAS CUSTOM: FAQ accordion. Single-open behavior. */
    document.addEventListener('click', function (e) {
      var q = e.target.closest('[data-cc-faq]');
      if (!q) return;
      var item = q.closest('.cc-faq-item');
      if (!item) return;
      var section = item.closest('.candelinas-cat');
      if (!section) return;
      var wasOpen = item.classList.contains('is-open');
      section.querySelectorAll('.cc-faq-item').forEach(function (i) {
        i.classList.remove('is-open');
      });
      if (!wasOpen) item.classList.add('is-open');
    });

    /* CANDELINAS CUSTOM: client-side scent filter (placeholder mode).
       Used when no Storefront filter is configured yet. Pills with
       data-cc-scent="<key>" hide product cards whose data-scent-family
       doesn't contain that key. The "all" key shows everything. */
    document.addEventListener('click', function (e) {
      var pill = e.target.closest('[data-cc-scent]');
      if (!pill) return;
      var section = pill.closest('.candelinas-cat');
      if (!section) return;
      var target = (pill.getAttribute('data-cc-scent') || '').toLowerCase();

      section.querySelectorAll('[data-cc-scent]').forEach(function (p) {
        p.classList.remove('is-active');
      });
      pill.classList.add('is-active');

      var cards = section.querySelectorAll('.cc-card[data-scent-family]');
      cards.forEach(function (card) {
        var fam = (card.getAttribute('data-scent-family') || '').toLowerCase();
        var match = target === 'all' || (fam && fam.indexOf(target) !== -1);
        card.style.display = match ? '' : 'none';
      });

      /* Hide the mid-grid upsell row while a scent filter is active — it
         spans full-width and looks awkward floating between 1 and 2 of
         filtered products. Show again on "All". */
      section.querySelectorAll('.cc-set-upsell').forEach(function (row) {
        row.style.display = target === 'all' ? '' : 'none';
      });
    });

    /* CANDELINAS CUSTOM: Judge.me preview-badge label cleanup — matches the
       snap-bars collection 1:1. Judge.me renders "1 review" / "292 reviews";
       we want just "(N)". Also nudge Judge.me to (re)render cached badges. */
    function ccCleanReviewBadges(root) {
      var nodes = (root || document).querySelectorAll('.cc-stars-wrap .jdgm-prev-badge__text');
      nodes.forEach(function (n) {
        var m = n.textContent.trim().match(/(\d+)/);
        if (!m) return;
        var pretty = '(' + m[1] + ')';
        if (n.textContent !== pretty) n.textContent = pretty;
      });
    }
    if (window.jdgm && window.jdgm.customizeBadges) {
      try { window.jdgm.customizeBadges(); } catch (e) {}
    }
    ccCleanReviewBadges();
    [200, 600, 1500, 3000].forEach(function (d) { setTimeout(ccCleanReviewBadges, d); });
    if ('MutationObserver' in window) {
      var ccCat = document.querySelector('.candelinas-cat');
      if (ccCat) {
        new MutationObserver(function () { ccCleanReviewBadges(ccCat); })
          .observe(ccCat, { childList: true, subtree: true, characterData: true });
      }
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
